//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TravelTime',

  data() {
    return {
      selectedCity: 'Москва',
      isOpen: false,
      cities: [
        {
          name: 'Москва',
          time: '2 ч. 55 мин.',
          distance: '1911 км'
        },
        {
          name: 'Санкт-Петербург',
          time: '3 ч. 10 мин.',
          distance: '2116 км'
        },
        {
          name: 'Екатеринбург',
          time: '2 ч. 15 мин.',
          distance: '674 км'
        }
      ]
    }
  },

  computed: {
    currentCity() {
      return (
        this.cities.find(city => city.name === this.selectedCity) ||
        this.cities[0]
      )
    }
  },

  methods: {
    selectCity(cityName) {
      this.selectedCity = cityName
      this.isOpen = false
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen
    }
  }
}
